import { actions } from "store/actions";

const initialState = {
  agencyInvoices: { result: [], count: 0 },
};

export const invoicesReducers = {
  agencyInvoices(state = initialState.agencyInvoices, action) {
    switch (action.type) {
      case actions.VM_SET_AGENCY_INVOICES:
        return action.payload;
      default:
        return state;
    }
  },
};

